import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const packingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createCheeksStripsData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/cheeks-strips/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['cheeks', 'strips', 'packingSummary', 'sortingSummary','packingSortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),

        createPackingData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/cso/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['strips', 'cheeks', 'packingSummary','packingRecordSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        createRefrigerationData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/refrigeration-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['refrigeration', 'packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        createPackingEmployeeData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/emp-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employee', 'packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")

            },

        }),
        getCheeksStripsData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/cheeks-strips/count?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['cheeks', 'strips'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRefrigerationData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/refrigeration-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['refrigeration'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getCheekStripPackedData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/cso/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['strips', 'cheeks'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPackingEmployeeData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/emp-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['employee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPackingSummary: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPackingRecordSummary: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/packing/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['packingRecordSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getLotNumber: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/lot-number/?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['lotNumber'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateEmployeeData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/emp-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateRefrigerationData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/refrigeration-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['refrigeration', 'packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        getBaggingLogs: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/packing-data/bagging/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['bagging'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createBaggingData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/bagging/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['bagging', 'baggingRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created","Bagging Record")
            },
        }),
        getBaggedRecord: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/packing-data/bagging/bagged-record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['baggingRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateBaggedRecord: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/bagging/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['bagging', 'baggingRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated" , "Bagging Record")
            },
        }),
        getCompletedRecord: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/packing-data/completed/record-list?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['completedRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createCompletedRecord: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/completed/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['bagging', 'completedRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created" , "Trays Completed Record")
            },
        }),
        updateCompletedRecord: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/completed/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['bagging', 'completedRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated" ,"Trays Completed Record")
            },
        }),
        getSortingSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/packing-data/sorting-summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['packingSortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getSeparationRecord: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/packing-data/separation/record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['separationRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createSeparationRecord: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/separation/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['separationRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Separation Record")
            },
        }),
        updateSeparationRecord: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/separation/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['separationRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Separation Record")
            },
        }),
        getPackingBandRecord: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/packing-data/packing-band/record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['packingBandRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createPackingBandRecord: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/packing-band/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['packingBandRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(
                    queryFulfilled, "Created", "Packing Band Record"
                );
            },
        }),
        updatePackingBandRecord: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/packing-band/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['packingBandRecord'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Packing Band Record")
            },
        }),

    }),
});

export const {

    useGetCheeksStripsDataQuery,
    useGetCheekStripPackedDataQuery,
    useGetPackingEmployeeDataQuery,
    useCreateCheeksStripsDataMutation,
    useCreatePackingDataMutation,
    useCreatePackingEmployeeDataMutation,
    useUpdateEmployeeDataMutation,
    useGetLotNumberQuery,
    useGetPackingSummaryQuery,
    useGetPackingRecordSummaryQuery,
    useGetRefrigerationDataQuery,
    useCreateRefrigerationDataMutation,
    useUpdateRefrigerationDataMutation,
    useGetBaggingLogsQuery,
    useCreateBaggingDataMutation,
    useGetBaggedRecordQuery,
    useUpdateBaggedRecordMutation,
    useGetCompletedRecordQuery,
    useCreateCompletedRecordMutation,
    useUpdateCompletedRecordMutation,
    useGetSortingSummaryQuery,
    useGetSeparationRecordQuery,
    useCreateSeparationRecordMutation,
    useUpdateSeparationRecordMutation,
    useGetPackingBandRecordQuery,
    useCreatePackingBandRecordMutation,
    useUpdatePackingBandRecordMutation


} = packingApi;